/**
 * Utility functions for i18n
 * @namespace Util.i18n
 */

import { i18n } from '@lingui/core';

/**
  * Allows arbitrary activation of Lingui translations
  * @function dynamicActivate
  * @memberof Util.i18n
  * @param {string} locale Language locale (should be provided by browser)
  * @returns {Promise}
  */
export async function dynamicActivate(locale = 'en') {
  try {
    const { messages } = await import(`../locales/${locale}.po`);

    i18n.load(locale, messages);
    return i18n.activate(locale);
  } catch (error) {
    console.error(`Failed to load locale messages for ${locale}:`, error);
    const { messages } = await import(`../locales/en.po`);

    i18n.load('en', messages);
    return i18n.activate('en');
  }
}
